// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesMegaDropdown_categories-mega-dropdown__h-lvC {
  background-color: #fff;
  padding: 5.7rem 7rem 8.9rem 7.4rem;
  border: 1px solid #00000033;
  border-inline-start: none;
  border-radius: 15px 0px 0px 15px;
  position: absolute;
  z-index: 10;
  top: 84px;
  right: 0;
  max-width: 120rem;
}

.CategoriesMegaDropdown_categories-mega-dropdown__lists__rM6jx {
  display: flex;
  flex-flow: row wrap;
  gap: 7rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .CategoriesMegaDropdown_categories-mega-dropdown__h-lvC {
    max-width: 90rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Navbar/NavSuggestions/CategoriesMegaDropdown/CategoriesMegaDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".categories-mega-dropdown {\n  background-color: #fff;\n  padding: 5.7rem 7rem 8.9rem 7.4rem;\n  border: 1px solid #00000033;\n  border-inline-start: none;\n  border-radius: 15px 0px 0px 15px;\n  position: absolute;\n  z-index: 10;\n  top: 84px;\n  right: 0;\n  max-width: 120rem;\n}\n\n.categories-mega-dropdown__lists {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 7rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .categories-mega-dropdown {\n    max-width: 90rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categories-mega-dropdown": `CategoriesMegaDropdown_categories-mega-dropdown__h-lvC`,
	"categories-mega-dropdown__lists": `CategoriesMegaDropdown_categories-mega-dropdown__lists__rM6jx`
};
export default ___CSS_LOADER_EXPORT___;
